module.exports = __webpack_public_path__ + "img/CH.f7d40833.svg";